import HelperMixin from "@/mixins/HelperMixin";
import { CurrencyValue } from "@/components/tableElements";
import PercentageValue from "@/components/tableElements/PercentageValue";
import PpcBudgetAllocationCircle from "@/components/PpcBudgetAllocationCircle";
import PpcBudgetAllocationWeeklyBudgetInput from "@/components/PpcBudgetAllocationWeeklyBudgetInput";
import PpcBudgetAllocationWeeklyBudgetCampaignBody from "@/components/PpcBudgetAllocationWeeklyBudgetCampaignBody.vue";
import TagIcon from "@/components/icons/TagIcon.vue";
import UserUpIcon from "@/components/icons/UserUpIcon.vue";
export default {
  name: "PpcBudgetAllocationWeeklyBudgetCampaign",
  emits: ["update-campaign"],
  mixins: [HelperMixin],
  components: {
    PpcBudgetAllocationCircle,
    PpcBudgetAllocationWeeklyBudgetInput,
    PercentageValue,
    CurrencyValue,
    PpcBudgetAllocationWeeklyBudgetCampaignBody,
    TagIcon,
    UserUpIcon
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: ""
    },
    currency: {
      type: String
    },
    country_code: {
      type: String
    }
  },
  methods: {
    getTitle() {
      const titleMap = {
        "MANU - EXACT": "Keyword Targeting",
        "MANU - PRODUCT": "Product Targeting",
        "AUTO": "Discovery Targeting - Auto",
        "MANU - BROAD": "Discovery Targeting - Broad"
      };
      return titleMap[this.item.type];
    },
    getClass() {
      const classMap = {
        "MANU - EXACT": "",
        "MANU - PRODUCT": "product",
        "AUTO": "",
        "MANU - BROAD": "product"
      };
      return classMap[this.item.type];
    },
    onInputUpdate(value) {
      this.$emit('update-campaign', {
        ...this.item,
        budgetCurrent: value
      });
    }
  }
};